import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app';

const container = document.getElementById('root') as HTMLElement;
const isPrerendered = container.hasChildNodes() && container.getAttribute('data-prerendered-for') === 'main';

const app = (
    <StrictMode>
        <App />
    </StrictMode>
);

if (isPrerendered) {
    ReactDOM.hydrateRoot(container, app);
} else {
    ReactDOM.createRoot(container).render(app);
}
